import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { COMMON } from 'utilities/constants/COMMON';

interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
}

const masked = (
    <div
        className="center-inside"
        style={{
            width: 40,
            height: 40,
            background: '#1F8DDD',
            color: '#ffffff',
            borderRadius: '50%',
            rotate: '-15deg',
            position: 'absolute',
            left: '-5px',
            bottom: '5px',
        }}
    >
        調査中
    </div>
);

export const ButtonGroup = ({ detailAssessment }: props) => {
    return (
        <section
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                height: 64,
                alignItems: 'center',
            }}
        >
            <div
                className={`button-group-element${
                    detailAssessment?.isAutolockExist == 0 ? '' : '-disabled'
                } center-inside relative`}
            >
                {detailAssessment?.isAutolockExist == 2 && masked}
                オートロック
            </div>
            <div
                className={`button-group-element${
                    detailAssessment?.isElevatorExist == 0 ? '' : '-disabled'
                } center-inside relative`}
            >
                {detailAssessment?.isElevatorExist == 2 && masked}
                エレベーター
            </div>
            <div className={`button-group-element center-inside`}>
                {detailAssessment?.bathToiletSeparatedDivName || COMMON.EMPTY}
            </div>
            <div
                className={`button-group-element${
                    detailAssessment?.indoorLaundryRoomDiv === '10' ? '' : '-disabled'
                } center-inside`}
            >
                室内洗濯機置き場
            </div>
        </section>
    );
};
